const width = "60.7%"
const height = "6.4%"
const left = "18.7%"
const isExternal = true
const iniTop = 12.4
const padding = 19.8 - iniTop


const links = [
    ["Supplier Security WebApp", "https://www.isflive.org/s/topic/0TO0J0000009AOCWA2/supply-chain"],
    ["Benchmark", "https://www.isflive.org/s/article/The-ISF-Benchmark?topicId=0TO0J0000009AOFWA2"],
    ["Standard of Good Practice for Information Security", "https://www.isflive.org/s/article/Standard-of-Good-Practice-for-Information-Security-2022-All-Files?topicId=0TO0J0000009AOIWA2"],
    ["SOGP WebApp", "https://www.isflive.org/s/article/SOGP-WebApp?topicId=0TO0J0000009AOIWA2"],
    ["Thread Horizon 2024", "https://www.isflive.org/s/article/Threat-Horizon-2024-the-disintegration-of-trust-report?topicId=0TO0J0000009AODWA2"],
    ["Information Security in Mergers & Acquisitions", "https://www.isflive.org/s/article/Information-Security-in-Mergers-and-Acquisitions?topicId=0TO6M0000005B8PWAU"],
    ["Cyber Insurance: Is worth the risk?", "https://www.isflive.org/s/article/Cyber-Insurance-Is-it-worth-the-risk"],
    ["Continuous Supply Chain Assurance", "https://www.isflive.org/s/article/continuous-supply-chain-assurance-report"],
    ["Supply Chain Assurance Framework", "https://www.isflive.org/s/article/Supply-Chain-Assurance-Framework-Contracting-in-confidence-Report?topicId=0TO0J0000009AOCWA2"],
    ["Legal and Regulatory Implications for Information Security", "https://www.isflive.org/s/article/Legal-and-Regulatory-Implications-for-Information-Security"]
].map((line, idx) => ({
    label: line[0],
    href: line[1],
    width, 
    height, 
    left, 
    isExternal, 
    top: `${iniTop + (padding * idx)}%`, 
    target: "_blank"
}))

export default [
    ...links, 
    {
        width: "28.7%",
        height: "5.4%",
        left: "34.7%",
        isExternal,
        top: "88%",
        target: "_blank",
        label: "For more, please visit the ISF Library",
        href: "https://www.isflive.org/s/knowledge-library"
    }
]